import { APP_NAME, LOGO, LOGO_DARK, LOGO_ICON } from "@calcom/lib/constants";
import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src = "/api/logo",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  const sizeClass = icon ? "mx-auto w-9" : small ? "h-4 w-auto" : "h-5 w-auto";
  const isDefaultApiLogo = src === "/api/logo";

  // Colored brand mark: don't use CSS invert (would ruin the blue "123").
  if (isDefaultApiLogo) {
    if (icon) {
      return (
        <h3 className={classNames("logo", inline && "inline", className)}>
          <strong>
            <img className={sizeClass} alt={APP_NAME} title={APP_NAME} src={LOGO_ICON} />
          </strong>
        </h3>
      );
    }

    return (
      <h3 className={classNames("logo", inline && "inline", className)}>
        <strong>
          <img
            className={classNames(sizeClass, "dark:hidden")}
            alt={APP_NAME}
            title={APP_NAME}
            src={LOGO_DARK}
          />
          <img
            className={classNames(sizeClass, "hidden dark:block")}
            alt={APP_NAME}
            title={APP_NAME}
            src={LOGO}
          />
        </strong>
      </h3>
    );
  }

  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img className={sizeClass} alt={APP_NAME} title={APP_NAME} src={`${src}?type=icon`} />
        ) : (
          <img className={sizeClass} alt={APP_NAME} title={APP_NAME} src={src} />
        )}
      </strong>
    </h3>
  );
}
